import type { GamblingContext } from '@/components/success-gambling/context';
import { createContext } from 'react';

const SuccessGamblingContext = createContext<GamblingContext>({
  answers: {},
  company: {
    isNoNameCompanyCase: false,
    href: '',
    label: '',
  },
  tips: [],
});

export default SuccessGamblingContext;

SuccessGamblingContext.displayName = 'SuccessGamblingContext';
